import { Alert } from "@norican/react";

import { useT } from "@/i18n";
import { useKiosk } from "@/lib/api";

export interface KioskTicketNumberNoteProps {
  /** The number to write down; nothing renders without one. */
  number: string | null | undefined;
  className?: string;
}

/**
 * "Note your ticket number: 12345", after filing on a shared device.
 *
 * There is no "My tickets" on a kiosk and the next person may sign the device
 * out, so the number is the only handle the person walks away with. Said
 * once, prominently, beside the success confirmation (1 Oct). Renders nothing
 * on a personal session.
 */
export function KioskTicketNumberNote({ number, className }: KioskTicketNumberNoteProps) {
  const { t } = useT("tickets");
  const kiosk = useKiosk();

  if (kiosk === null || number == null || number === "") {
    return null;
  }

  return (
    <Alert tone="info" title={t("kiosk.noteNumberTitle", { number })} className={className}>
      {t("kiosk.noteNumberBody")}
    </Alert>
  );
}
